import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_FLAG,
} from "./actionTypes";

export const resetPassword = (user) => {
  return {
    type: RESET_PASSWORD,
    payload: { user },
  };
};

export const resetPasswordSuccess = (user) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: user,
  };
};

export const resetPasswordError = (error) => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: error,
  };
};

export const resetPasswordFlag = () => {
  return {
    type: RESET_PASSWORD_FLAG,
  };
};
